/**
 * クエリ文字列生成
 * @param params クエリパラメータのObject
 * @returns クエリ文字列
 */
const createQueryString = (params: Object) =>
  Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join("&");

/**
 * リクエストURL生成
 * @param url URL
 * @param queryParams クエリパラメータのObject
 * @returns 生成したクエリ付きのURL
 */
export function createUrl(url: string, queryParams: Object) {
  return `${url}?${createQueryString(queryParams)}`;
}

/**
 * APIで使用する日付文字列へ変換
 * @param date 変換するDateオブジェクト
 * @returns 日付文字列（yyyy-MM-dd）
 */
export function formatApiDateString(date: Date) {
  return date
    .toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replaceAll("/", "-");
}

/**
 * APIで使用する時刻文字列へ変換
 * @param date 変換するDateオブジェクト
 * @returns 時刻文字列（hh:mm）
 */
export function formatApiTimeString(date: Date) {
  return date
    .toLocaleTimeString("ja-JP", {
      hour: "2-digit",
      minute: "2-digit",
    })
    .slice(0, 5);
}

/**
 * APIで使用する日時文字列へ変換
 * @param date 日付（yyyy/MM/dd）
 * @param time 時刻（hh:mm）
 * @returns 日時文字列（yyyy-MM-ddThh:mm:ss[.SSS]Z）
 */
export function formatApiDatetimeString(date: string, time: string) {
  return new Date(`${date} ${time}`).toISOString();
}

/**
 * APIで使用する日付文字列へ変換
 * @param date 変換するDateオブジェクト
 * @returns 日付文字列（yyyyMMdd）
 */
export function formatApiYmdString(date: Date) {
  return date
    .toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replaceAll("/", "")
    .slice(0, 8);
}

export function isSameDate(date: Date, isoDatetime: string) {
  return formatApiDateString(date) === formatApiDateString(new Date(isoDatetime));
}
